import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12",
  style: {"font-family":"PantonRegular"}
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl pb-16" }
const _hoisted_3 = {
  key: 0,
  class: "font-bold text-gray-800 mb-4 text-lg text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "font-bold text-gray-800 mb-4 text-lg text-center text-uppercase"
}
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_6 = {
  key: 0,
  class: "w-full px-2 text-center"
}
const _hoisted_7 = {
  key: 0,
  class: "block mb-3 font-bold text-3xl text-red-600"
}
const _hoisted_8 = { class: "block mb-3 font-bold text-3xl" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "block mb-3 font-bold text-3xl" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "line-through text-red-600"
}
const _hoisted_14 = {
  key: 3,
  class: "text-green-600"
}
const _hoisted_15 = {
  key: 1,
  class: "w-full px-2 text-center"
}
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 bg-gray-200 rounded-lg border border-gray-800 px-2 py-6 shadow-md" }
const _hoisted_17 = { class: "w-full px-2 text-center" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-8" }
const _hoisted_20 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_23 = { class: "text-sm text-red-500 p-error" }
const _hoisted_24 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_25 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_26 = { class: "text-sm text-red-500 p-error" }
const _hoisted_27 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_30 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_31 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_32 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_33 = { class: "text-sm text-red-500 p-error" }
const _hoisted_34 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_35 = { class: "text-sm text-red-500 p-error" }
const _hoisted_36 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_37 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_38 = { class: "text-sm text-red-500 p-error" }
const _hoisted_39 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_40 = { class: "text-sm text-red-500 p-error" }
const _hoisted_41 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2" }
const _hoisted_42 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_43 = { class: "text-sm text-red-500 p-error" }
const _hoisted_44 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_45 = { class: "text-sm text-red-500 p-error" }
const _hoisted_46 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_49 = { class: "pi pi-shopping-cart mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[28] || (_cache[28] = _createElementVNode("h1", {
              class: "font-bold text-gray-800 mb-4 text-2xl text-center",
              style: {"font-family":"PantonBold"}
            }, [
              _createTextVNode(" POR FAVOR COMPLETE EL FORMULARIO PARA ADQUIRIR SU ENTRADA."),
              _createElementVNode("br")
            ], -1)),
            (!_ctx.isFree)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_3, " UNA VEZ COMPLETADO EL FORMULARIO SERA REDIRIGIDO A MERCADOPAGO PARA REALIZAR EL PAGO. "))
              : _createCommentVNode("", true),
            (_ctx.isFree)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_4, " Una vez completado el formulario, te encontrarás inscripto al evento "))
              : _createCommentVNode("", true),
            _cache[29] || (_cache[29] = _createElementVNode("h1", { class: "font-bold text-gray-800 mb-4 text-lg text-center pb-5" }, " La entrada es personal e intransferible ", -1)),
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.isFree)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (!_ctx.producto)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_7, "ENTRADAS AGOTADAS"))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_8, [
                      (_ctx.producto)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "ENTRADA :" + _toDisplayString(_ctx.producto.descripcion.toUpperCase()), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", _hoisted_10, [
                      (_ctx.producto)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " VALOR : "))
                        : _createCommentVNode("", true),
                      (_ctx.producto && _ctx.producto.precioUnitario == 220000)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " $ 220.000 "))
                        : _createCommentVNode("", true),
                      (_ctx.producto && _ctx.producto.precioUnitario < 220000)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " $ 220.000 "))
                        : _createCommentVNode("", true),
                      (_ctx.producto && _ctx.producto.precioUnitario < 220000)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(' $ ' +
                _ctx.formatNumber(_ctx.producto.precioUnitario)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isFree)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[13] || (_cache[13] = [
                    _createElementVNode("label", { class: "block mb-3 font-bold text-3xl" }, "Invitación exclusiva sin cargo", -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-3" }, "Si posee un código de descuento ingreselo aquí (Opcional)", -1)),
                _createVNode(_component_Field, {
                  name: "codigoDescuento",
                  modelValue: _ctx.formData.codigoDescuento,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.codigoDescuento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      onBlur: _ctx.validarCodigoDescuento,
                      placeholder: "Código de descuento",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["onBlur", "class"]),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "codigoDescuento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block mb-1" }, "Documento", -1)),
                _createVNode(_component_Field, {
                  name: "documento",
                  modelValue: _ctx.formData.documento,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.documento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      onBlur: _ctx.validarDni,
                      placeholder: "Ingrese su documento",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["onBlur", "class"]),
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "documento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1" }, "Email", -1)),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su email",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su nombre",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su apellido",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_28, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1" }, "País", -1)),
                _createVNode(_component_Select, {
                  modelValue: _ctx.selectedCountry,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                  filter: "",
                  options: _ctx.paises,
                  optionLabel: "value",
                  placeholder: "Select a Country",
                  class: "input-base"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)),
                (_ctx.selectedCountry !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.selectedCountry.code,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCountry.code) = $event)),
                      class: "input-base",
                      readonly: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)),
                _createVNode(_component_Field, {
                  name: "codigoArea",
                  modelValue: _ctx.formData.codigoArea,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)),
                _createVNode(_component_Field, {
                  name: "telefonoCelular",
                  modelValue: _ctx.formData.telefonoCelular,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_35, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block mb-1" }, "Empresa", -1)),
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su empresa",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_38, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block mb-1" }, "Provincia", -1)),
                _createVNode(_component_Field, {
                  name: "provincia",
                  modelValue: _ctx.formData.provincia,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.provincia) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione la provincia",
                      options: _ctx.provincias,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_40, [
                      _createVNode(_component_ErrorMessage, { name: "provincia" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            (!_ctx.isFree)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-6" }, [
                    _createElementVNode("div", { class: "w-full px-2" }, [
                      _createElementVNode("h2", { class: "font-bold text-gray-700 text-lg border-b border-gray-300 pb-2 mb-4" }, "Datos de Facturación")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block mb-1" }, "Condición de IVA", -1)),
                      _createVNode(_component_Field, {
                        name: "condicionIva",
                        modelValue: _ctx.formData.condicionIva,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.condicionIva) = $event))
                      }, {
                        default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                          _createVNode(_component_Select, {
                            onBlur: handleBlur,
                            "onUpdate:modelValue": handleChange,
                            "model-value": value,
                            placeholder: "Seleccione condición de IVA",
                            options: _ctx.condicionesIva,
                            optionLabel: "descripcion",
                            class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                          }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                          _createElementVNode("span", _hoisted_43, [
                            _createVNode(_component_ErrorMessage, { name: "condicionIva" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block mb-1" }, "CUIT", -1)),
                      _createVNode(_component_Field, {
                        name: "cuit",
                        modelValue: _ctx.formData.cuit,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.cuit) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputMask, _mergeProps(field, {
                            mask: "99-99999999-9",
                            placeholder: "XX-XXXXXXXX-X",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_45, [
                            _createVNode(_component_ErrorMessage, { name: "cuit" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_48, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_49, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(_toDisplayString(_ctx.isFree ? 'ADQUIRIR ENTRADA' : 'COMPRAR'), 1)
              ], 8, _hoisted_47)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]),
      _createVNode(_component_BlockUI, {
        blocked: _ctx.isSubmitting,
        fullScreen: ""
      }, null, 8, ["blocked"])
    ])
  ], 64))
}